import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import { computed, set } from '@ember/object';
import Model, { attr, hasMany, belongsTo } from '@ember-data/model';
import { cached, tracked } from '@glimmer/tracking';
import { inject } from '@ember/service';
import getConfig from 'beebee-base/lib/get-config';
import { _saveAll, _safeReload, _sortedCustomFields, _createLabel, applyStyle } from '../lib/utility.js';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48;
let ProductModel = (_dec = attr('boolean'), _dec2 = attr('string'), _dec3 = attr('boolean'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('boolean'), _dec7 = attr('number'), _dec8 = attr('number', {
  currency: true
}), _dec9 = attr('number', {
  currency: true
}), _dec0 = attr('string'), _dec1 = attr('number'), _dec10 = attr('number'), _dec11 = attr('number'), _dec12 = attr('number'), _dec13 = attr('number'), _dec14 = attr('number'), _dec15 = attr('boolean'), _dec16 = attr('string'), _dec17 = attr('number'), _dec18 = attr('string'), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('string'), _dec22 = attr('boolean'), _dec23 = attr('string'), _dec24 = computed('_tmpOption', 'option'), _dec25 = attr('string'), _dec26 = computed('_tmpModule', 'modules'), _dec27 = attr('string'), _dec28 = hasMany('address', {
  inverse: null,
  async: false
}), _dec29 = hasMany('product', {
  inverse: null,
  async: true
}), _dec30 = hasMany('contact', {
  inverse: null,
  async: true
}), _dec31 = hasMany('project', {
  inverse: null,
  async: true
}), _dec32 = hasMany('event', {
  inverse: null,
  async: true
}), _dec33 = hasMany('todolist', {
  inverse: 'product',
  async: false
}), _dec34 = hasMany('custom_field', {
  inverse: null,
  async: false
}), _dec35 = hasMany('payment', {
  inverse: null,
  async: false
}), _dec36 = hasMany('file', {
  inverse: null,
  async: true
}), _dec37 = attr('number', {
  defaultValue: 0
}), _dec38 = attr('number', {
  defaultValue: 0
}), _dec39 = attr('number', {
  defaultValue: 0
}), _dec40 = attr('number', {
  defaultValue: 0
}), _dec41 = attr('number', {
  defaultValue: 0
}), _dec42 = attr('number', {
  defaultValue: 0
}), _dec43 = belongsTo('product_state', {
  inverse: null,
  async: false
}), _dec44 = hasMany('product_category', {
  inverse: null,
  async: false
}), _dec45 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec46 = attr('boolean', {
  defaultValue: false
}), _class = class ProductModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "log", _descriptor3, this);
    _initializerDefineProperty(this, "checked", _descriptor4, this);
    _initializerDefineProperty(this, "archivied", _descriptor5, this);
    _initializerDefineProperty(this, "created_at", _descriptor6, this);
    _initializerDefineProperty(this, "teleconsulto", _descriptor7, this);
    _initializerDefineProperty(this, "name", _descriptor8, this);
    _initializerDefineProperty(this, "description", _descriptor9, this);
    _initializerDefineProperty(this, "is_group", _descriptor0, this);
    _initializerDefineProperty(this, "max_group", _descriptor1, this);
    _initializerDefineProperty(this, "price", _descriptor10, this);
    _initializerDefineProperty(this, "cost", _descriptor11, this);
    _initializerDefineProperty(this, "codice", _descriptor12, this);
    _initializerDefineProperty(this, "dispo", _descriptor13, this);
    _initializerDefineProperty(this, "larghezza", _descriptor14, this);
    _initializerDefineProperty(this, "lunghezza", _descriptor15, this);
    _initializerDefineProperty(this, "profondita", _descriptor16, this);
    _initializerDefineProperty(this, "altezza", _descriptor17, this);
    _initializerDefineProperty(this, "duration", _descriptor18, this);
    _initializerDefineProperty(this, "set_event_color", _descriptor19, this);
    _initializerDefineProperty(this, "color", _descriptor20, this);
    _initializerDefineProperty(this, "over_price", _descriptor21, this);
    _initializerDefineProperty(this, "thumbnail_url", _descriptor22, this);
    _initializerDefineProperty(this, "thumbnail_name", _descriptor23, this);
    _initializerDefineProperty(this, "thumbnail_etag", _descriptor24, this);
    _initializerDefineProperty(this, "thumbnail_type", _descriptor25, this);
    _initializerDefineProperty(this, "dispo_online", _descriptor26, this);
    _initializerDefineProperty(this, "option", _descriptor27, this);
    _initializerDefineProperty(this, "modules", _descriptor28, this);
    _initializerDefineProperty(this, "notes", _descriptor29, this);
    _initializerDefineProperty(this, "addresses", _descriptor30, this);
    _initializerDefineProperty(this, "related_products", _descriptor31, this);
    _initializerDefineProperty(this, "contacts", _descriptor32, this);
    _initializerDefineProperty(this, "projects", _descriptor33, this);
    _initializerDefineProperty(this, "events", _descriptor34, this);
    _initializerDefineProperty(this, "todolists", _descriptor35, this);
    _initializerDefineProperty(this, "custom_fields", _descriptor36, this);
    _initializerDefineProperty(this, "payments", _descriptor37, this);
    _initializerDefineProperty(this, "files", _descriptor38, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor39, this);
    _initializerDefineProperty(this, "total_contacts_number", _descriptor40, this);
    _initializerDefineProperty(this, "total_projects_number", _descriptor41, this);
    _initializerDefineProperty(this, "total_payments_number", _descriptor42, this);
    _initializerDefineProperty(this, "total_events_number", _descriptor43, this);
    _initializerDefineProperty(this, "total_related_products_number", _descriptor44, this);
    _initializerDefineProperty(this, "product_state", _descriptor45, this);
    _initializerDefineProperty(this, "product_categories", _descriptor46, this);
    _initializerDefineProperty(this, "current_users", _descriptor47, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor48, this);
  }
  get idArray() {
    return [this.id];
  }
  saveAll(model) {
    return _saveAll(model, this.session, 'products_all');
  }
  safeReload() {
    return _safeReload(this);
  }
  get thumbnail_api_url() {
    if (!this.session.token || !this.thumbnail_url) {
      return null;
    }
    return `${getConfig(this).APP.urlApi}/app/file?access_token=${this.session.token}&name=${encodeURIComponent(this.thumbnail_name ?? '')}&url=${encodeURIComponent(this.thumbnail_url)}`;
  }
  get option_json() {
    if (this._tmpOption) {
      return this._tmpOption;
    } else if (!this.option) {
      return null;
    }
    try {
      return JSON.parse(this.option);
    } catch (e) {
      this.log.error(e);
      return null;
    }
  }
  set option_json(value) {
    set(this, '_tmpOption', value);
  }
  get modules_json() {
    if (this._tmpModule) {
      return this._tmpModule;
    } else if (!this.modules) {
      return null;
    }
    try {
      return JSON.parse(this.modules);
    } catch (e) {
      this.log.error(e);
      return null;
    }
  }
  set modules_json(value) {
    set(this, '_tmpModule', value);
  }
  get sorted_custom_fields() {
    let fields;
    try {
      fields = this.custom_fields;
    } catch {
      return [];
    }
    if (Array.isArray(fields)) {
      return _sortedCustomFields(fields, this.isDeleted);
    }
    if (fields && typeof fields.then === 'function') {
      return fields.then(resolvedFields => _sortedCustomFields(resolvedFields, this.isDeleted));
    }
    return [];
  }
  get label() {
    const cLabel = this.session.option_field?.model_custom_label?.product?.label;
    if (cLabel) {
      return _createLabel(this, cLabel, this.session, this.intl, this.currency);
    }
    const styleName = this.session.option_field?.model_custom_style?.product;
    return applyStyle(this.name, styleName);
  }
  get sub_label() {
    const cSubLabel = this.session.option_field?.model_custom_label?.product?.sub_label;
    if (cSubLabel) {
      return _createLabel(this, cSubLabel, this.session, this.intl, this.currency);
    }
    return this.description ? this.description : '';
  }
  get status_name() {
    return this.product_state?.status_name;
  }
  get firstLetters() {
    const name = this.name || '';
    const words = name.trim().split(' ');
    const initials = words.filter(word => word.length > 0).slice(0, 3).map(word => word[0].toUpperCase()).join('');
    return initials || '-';
  }
  get firstLetter() {
    if (this.name && this.name.length > 0) {
      return this.name[0].toLowerCase();
    }
    return '';
  }
  get current_users_label() {
    return this.current_users.map(user => user.label).join(' ');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "log", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "archivied", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "teleconsulto", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "is_group", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "max_group", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "price", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "cost", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "codice", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "dispo", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "larghezza", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "lunghezza", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "profondita", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "altezza", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "duration", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "set_event_color", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "over_price", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_url", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_name", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_etag", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_type", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "dispo_online", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "option", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "option_json", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "option_json"), _class.prototype), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "modules", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "modules_json", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "modules_json"), _class.prototype), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "addresses", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "related_products", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "projects", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "events", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "todolists", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "custom_fields", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sorted_custom_fields", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sorted_custom_fields"), _class.prototype), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "payments", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "total_contacts_number", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "total_projects_number", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "total_payments_number", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "total_events_number", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "total_related_products_number", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "product_state", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "product_categories", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "current_users", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ProductModel as default };
//# sourceMappingURL=product.js.map
